<zef-sidenav>
  <ng-container *zefSidenavTitle>
    @if (contact$ | async; as contact) {
      @if (!contact.id) {
        <ng-container i18n>New contact</ng-container>
      }
      @if (contact.id) {
        <ng-container i18n>Edit contact</ng-container>
      }
    }
  </ng-container>

  <ng-container *zefSidenavButtonPrimary>
    @if (contact$ | async; as contact) {
      <button
        mat-raised-button
        [color]="contact.id ? 'primary' : 'success'"
        [loading]="loading$ | async"
        [disabled]="!contact.id && contactsRemaining() <= 0"
        (click)="onSaveContact(contact)"
      >
        @if (!contact.id) {
          <ng-container i18n>Create contact</ng-container>
        }
        @if (contact.id) {
          <ng-container i18n>Save</ng-container>
        }
      </button>
    }
  </ng-container>

  @if ((contact$ | async)?.id || contactsRemaining()) {
    <mat-menu zefSidenavMenu>
      @if (contact$ | async; as contact) {
        @if (!contact.id) {
          <div mat-menu-item i18n (click)="onSaveContact(contact, true)">Save and create another</div>
        }
        <div class="zef-menu-item-alert" mat-menu-item i18n (click)="sidenav?.closeSidenav()">Discard</div>
      }
    </mat-menu>
  }

  <div *zefSidenavContent class="contact-body">
    @if (contact$ | async; as contact) {
      @if (!contact.id && contactsRemaining() <= 0) {
        <div class="contact-limit z-fx-col z-fx-gap-16">
          <div class="zef-text-p1" i18n>Your organization has reached its maximum Contacts limit.</div>
          <button mat-raised-button class="zef-cta-button" color="contacts" routerLink="/plans" i18n>
            Get more Contacts
          </button>
          <div routerLink="/settings/billing" class="z-fx z-fx-gap-8 z-fx-start-center zef-text-link">
            <div class="zef-text-p2 zef-text-light">Go to Plan & Billing</div>
            <mat-icon class="zef-icon-small">new_tab</mat-icon>
          </div>
        </div>
      }
      <div class="contact-body-inner z-fx-col z-fx-gap-32">
        <div class="contact-image zef-avatar-contact z-fx z-fx-center-center z-fx-none">
          <zef-image-upload
            mode="avatar"
            directory="contact-avatars"
            fit="cover"
            size="small-medium"
            [source]="(contact$ | async)?.thumb"
            (sourceChange)="onAvatarUploaded($event.image.urls)"
          ></zef-image-upload>
        </div>
        <div class="contact-columns z-fx-col z-fx-gap-24">
          @for (column of columns$ | async; track column; let index = $index) {
            @if (index === 2) {
              <mat-divider></mat-divider>
              <div class="z-fx-col z-fx-gap-8">
                <div class="zef-text-h3" i18n>Add to list</div>
                <zef-select
                  placeholder="Select a list..."
                  i18n-placeholder
                  [canClear]="true"
                  clearHint="No list"
                  i18n-clearHint
                  [readOnly]="readonlyAddList"
                  [value]="addToList"
                  (change)="addToList = $event"
                >
                  @for (list of contactLists(); track trackByList($index, list)) {
                    <zef-select-option [value]="list.id">
                      {{ list?.name }}
                    </zef-select-option>
                  }
                </zef-select>
              </div>
              <mat-divider></mat-divider>
            }
            <div class="z-fx-col z-fx-gap-8">
              <div
                class="z-fx z-fx-between-center z-fx-gap-8 zef-text-overflow-line"
                [class.zef-text-h3]="index < 2"
                [class.zef-text-p2]="index >= 2"
              >
                <div class="zef-text-ellipsis">
                  {{ column.name }}
                </div>
                @if (index >= 2) {
                  <span class="zef-text-light">
                    {{ cm.getColumnTypeName(column.type) }}
                  </span>
                }
              </div>
              @if (column.type !== 'date') {
                <mat-form-field class="zef-input-small zef-input-space">
                  @if (column.$key === 'phone') {
                    <input
                      matInput
                      placeholder="{{ column.name }} starting with +..."
                      [(ngModel)]="contact.phone"
                      [ngModelOptions]="{ updateOn: 'blur' }"
                      (blur)="onPhoneBlur(contact)"
                    />
                  }
                  @if (column.$key !== 'phone') {
                    <input
                      matInput
                      placeholder="{{ column.name }}..."
                      [(ngModel)]="contact[column.$key]"
                      [ngModelOptions]="{ updateOn: 'blur' }"
                    />
                  }
                </mat-form-field>
              }
              @if (column.type === 'date') {
                <mat-form-field class="zef-input-small zef-input-space">
                  <mat-datepicker #picker></mat-datepicker>
                  <input
                    matInput
                    placeholder="{{ column.name }}..."
                    [(ngModel)]="contact[column.$key]"
                    [ngModelOptions]="{ updateOn: 'blur' }"
                    [matDatepicker]="picker"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon>calendar</mat-icon>
                  </mat-datepicker-toggle>
                </mat-form-field>
              }
              @if (
                column.$key === 'email' &&
                contact.email &&
                (!this.isValidEmail(contact.email) || duplicateError === 'email')
              ) {
                <mat-error>
                  @if (!this.isValidEmail(contact.email)) {
                    <ng-container i18n>Please enter a valid email address</ng-container>
                  }
                  @if (duplicateError === 'email') {
                    <ng-container i18n>A contact with this email already exists</ng-container>
                  }
                </mat-error>
              }
              @if (
                column.$key === 'phone' &&
                contact.phone &&
                (!this.isValidPhone(contact.phone) || duplicateError === 'phone')
              ) {
                <mat-error>
                  @if (!this.isValidPhone(contact.phone)) {
                    <ng-container i18n>Please enter a valid Phone Number starting with +</ng-container>
                  }
                  @if (duplicateError === 'phone') {
                    <ng-container i18n>A contact with this Phone Number already exists</ng-container>
                  }
                </mat-error>
              }
              @if (index >= 2 && !this.isValidColumn(contact[column.$key], column.type)) {
                <mat-error>
                  <ng-container i18n>This does not look like a</ng-container>
                  {{ cm.getColumnTypeName(column.type) }} field
                </mat-error>
              }
            </div>
            @if (index === 1 && submitted && !contact.email && !contact.phone) {
              <mat-error i18n>At least an Email, or Phone Number is required</mat-error>
            }
          }
        </div>
      </div>
    }
  </div>
</zef-sidenav>
